export function getNavSelectedKey(pathname) {
  if (!pathname || pathname === '/') {
    return '/'
  }
  if (pathname.startsWith('/outline')) {
    return '/outline/'
  }
  if (pathname.startsWith('/bores')) {
    return '/bores/'
  }
  if (pathname.startsWith('/calendar')) {
    return '/calendar'
  }
  if (pathname.startsWith('/timesheets')) {
    return '/timesheets'
  }
  if (pathname.startsWith('/maintenance')) {
    return '/maintenance/'
  }
  if (pathname.startsWith('/prestarts')) {
    return '/prestarts/'
  }
  if (pathname.startsWith('/profile')) {
    return '/profile/'
  }
  if (pathname.startsWith('/developer')) {
    return '/developer/'
  }
  if (pathname.startsWith('/explosive')) {
    return '/explosive-inv'
  }
  return pathname
}

export function getNavOpenKeys(pathname) {
  if (pathname.startsWith('/developer') || pathname.startsWith('/explosive')) {
    return ['sub2']
  }
  return []
}
